const all = ['gauss']
const iframeUrl = () => [...all, 'iframe-url']

export const gaussKeys = {
  all,
  iframeUrl,
}
